module.exports = __webpack_public_path__ + "static/img/6_1_1.357abad1.jpg";